import React,{useState,useEffect}from 'react'
import {Button,Empty} from 'antd'

interface EProps {
  fn: () => void
}

const EmptyCom: React.FC<EProps> = ({fn}) => {
  const [disabled, setDisabled] = useState(false)
  useEffect(() => {
    let u = JSON.parse(sessionStorage.getItem('user-info') || '{}')
    if (u.type === 'guest') {
      setDisabled(true)
    }
  }, [])
  return (
    <div className="empty-course-annexes">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <span>
            没有数据
            <Button type="link" style={{padding: 0}} onClick={fn} disabled={disabled}>
              去添加
            </Button>
          </span>
        }
      ></Empty>
    </div>
  )
}

export default EmptyCom